import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ToastMessage } from "../../components/Notify";
import { ClientSettings } from "../../models/APIModels";
import { RootState } from ".";
import { ApiHelper } from "../../common/ApiHelper";

export type ApplicationDataState = {
    toastMessage: ToastMessage | null;
    confirmMessage?: string | null;
    globalData: ClientSettings | any;
  };


  export const initialState: ApplicationDataState = {
    globalData: null,
    confirmMessage: null,
    toastMessage: null
  };

  const applicationDataSlice = createSlice({
    name: 'applicationData',
    initialState,
    reducers: {
      setClientSettings: (state, action) => {
        state.globalData = action.payload;
      },
      SetNotifyMessage: (state, action: any) => {
        // console.log('state--SetNitifyMessage', action)
        state.toastMessage = action.payload;
      },
      SetConfirmMessage: (state, action: any) => {
        // console.log('state--SetNitifyMessage', action)
        state.confirmMessage = action.payload;
      },
    },
  });

  export const {  setClientSettings, SetNotifyMessage, SetConfirmMessage } = applicationDataSlice.actions;
  
  // export clientSettings selector to get the slice in any component
  export const applicationDataSelector = (state: RootState) => state.applicationData;

  const applicationDataReducer = applicationDataSlice.reducer;
  export default applicationDataReducer;

  export const getClientSettings =  () => {
    // console.log('getClientSettings')
    return async dispatch => {
        try {
            let {data} = await ApiHelper.GetClientSettings();
            dispatch(setClientSettings(data))
        }
        catch(e){
            console.log(e)
        }
    }
}

export const setConfirmationMessage = createAsyncThunk(
  'applicationData/setConfirmationMessage',
  async (value: string | null, { dispatch }) => {
    dispatch(SetConfirmMessage(value));
  }
);

  